import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ts_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  login: (booking_id, last_name, password = "") =>
    api.post("/auth/login", { booking_id, last_name, password }).then((r) => r.data),
  // El campo "Clave" se manda como last_name Y password: el backend usa
  // last_name (comportamiento original) si esa cuenta nunca generó una
  // contraseña real, o password (hasheada) si ya se le reseteó una.
  adminLogin: (booking_id, clave) =>
    api.post("/auth/admin", { booking_id, last_name: clave, password: clave }).then((r) => r.data),
  me: () => api.get("/me").then((r) => r.data),
  save: (data) => {
    localStorage.setItem("ts_token", data.token);
    localStorage.setItem("ts_user", JSON.stringify(data));
  },
  logout: () => {
    localStorage.removeItem("ts_token");
    localStorage.removeItem("ts_user");
  },
  current: () => {
    try { return JSON.parse(localStorage.getItem("ts_user")); } catch { return null; }
  },
};
